import _ from "lodash";
import { NotificationManager } from "react-notifications";

import apiURL from'./apiURL';
import cleanDeep from "clean-deep";

const Types = {
  ASSET_SAVED: "ASSET_SAVED",
  ASSET_TAB: "ASSET_TAB",
  ASSET_LIST: "ASSET_LIST",
  ASSET_GET: "ASSET_GET",
  ASSET_CLEAR: "ASSET_CLEAR",
  ASSET_SAVING: "ASSET_SAVING",
  ASSET_NEW_MODAL: "ASSET_NEW_MODAL",
  ASSET_AUDIT_LOGS: "ASSET_AUDIT_LOGS",
  ASSET_ASSIGN_MODAL: "ASSET_ASSIGN_MODAL",
  ASSET_UNASSIGN_MODAL: "ASSET_UNASSIGN_MODAL",
  ASSET_HISTORY: "ASSET_HISTORY"
}

const assetSaving = (response) => ({
  type: Types.ASSET_SAVING,
  payload: response,
})
const assetSaved = (response) => ({
  type: Types.ASSET_SAVED,
  payload: response,
})

const assetList = (response) => ({
  type: Types.ASSET_LIST,
  payload: response,
})
const assetHistory = (response) => ({
  type: Types.ASSET_HISTORY,
  payload: response,
})

const assetGet = (payload) => ({
  type: Types.ASSET_GET,
  payload,
})

const assetTab = (tab) => ({
  type: Types.ASSET_TAB,
  tab,
});

const toggleNewModal = (toggle) => ({
  type: Types.ASSET_NEW_MODAL,
  toggle
});

const assignEmployeeModal = (toggle) => ({
  type: Types.ASSET_ASSIGN_MODAL,
  toggle
});

const unassignEmployeeModal = (toggle) => ({
  type: Types.ASSET_UNASSIGN_MODAL,
  toggle
});

const clearAsset = () => ({
  type: Types.ASSET_CLEAR,
})

const saveAsset = (input) => {
  return async (dispatch, getState) => {

    const state = getState();

    input.id = state.asset?.item?.id
    delete input?.assignedTo
    delete input?.history

    dispatch(assetSaving())

    const response = await fetch(apiURL + `/settings/asset`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(cleanDeep(input)),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(assetSaved(data))
        NotificationManager.success('Asset has been saved successfully!', 'Saving Asset')

        if (state.asset?.newModal) {
          dispatch(toggleNewModal())
          dispatch(getAssets())
        } else {
          dispatch(getAsset(state.asset?.item?.id))
        }
      })
      .catch(error => {
        console.error(error)
        NotificationManager.error('Error Saving Asset', 'Saving Asset')
      })
  }
}

const assignAsset = (input) => {
  return async (dispatch, getState) => {

    const state = getState();

    // input.id = state.asset?.item?.id

    dispatch(assetSaving())

    await fetch(apiURL + `/settings/asset/assign`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(cleanDeep(input)),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(assetSaved(data))
        NotificationManager.success('Asset has been assigned!', 'Assigning Asset')

        if (state.asset?.assignModal) {
          dispatch(assignEmployeeModal())
          dispatch(getAsset(state.asset?.item?.id))
        }
      })
      .catch(error => {
        console.error(error)
        NotificationManager.error('Error Assigning Asset', 'Assigning Asset')
      })
  }
}

const unassignAsset = (input) => {
  return async (dispatch, getState) => {

    const state = getState();

    // input.id = state.asset?.item?.id

    const assigned = {
      ...state.asset?.item?.assignedTo,
      ...input
    }

    dispatch(assetSaving())

    await fetch(apiURL + `/settings/asset/unassign`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(cleanDeep(assigned)),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(assetSaved(data))
        NotificationManager.success('Asset has been unassigned!', 'Unassigning Asset')

        if (state.asset?.unassignModal) {
          dispatch(unassignEmployeeModal())
          dispatch(getAsset(state.asset?.item?.id))
        }
      })
      .catch(error => {
        console.error(error)
        NotificationManager.error('Error unassigning Asset', 'Unassigning Asset')
      })
  }
}

const getAssignmentHistory = (id) => {
  return async (dispatch, getState) => {
    const state = getState();

    //   const employeeId = state.employee.employeeDetails.employee_id

    const response = await fetch(apiURL + `/settings/asset/assignments/${id}`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        console.log('entity data', data)
        dispatch(assetHistory(data))
      })
  }
}

const getAssets = () => {
  return async (dispatch, getState) => {

    const state = getState();

    //   const employeeId = state.employee.employeeDetails.employee_id

    const response = await fetch(apiURL + `/settings/asset`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        console.log('entity data', data)
        dispatch(assetList(data))
      })


  }
}
const getAsset = (id) => {
  return async (dispatch, getState) => {

    const state = getState();

    const response = await fetch(apiURL + `/settings/asset/${id}`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(assetGet(data))
      })
  }
}

const setAuditLogs = (response, nextToken) => ({
  type: Types.ASSET_AUDIT_LOGS,
  payload: response,
  extend: nextToken ? true : false,
});

const getAssetAuditLogs = ({ assetId, nextToken, from, to }) => {
  return async (dispatch, getState) => {

    const state = getState();

    const qs = new URLSearchParams(cleanDeep({
      from,
      to,
      nextToken
    })).toString();

    const response = await fetch(apiURL + `/settings/auditLogs/asset/${assetId}?${qs}`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        dispatch(setAuditLogs(data, nextToken))
      })
  }
}

const Actions = {
  saveAsset,
  assetTab,
  getAssets,
  getAsset,
  clearAsset,
  toggleNewModal,
  getAssetAuditLogs,
  assignEmployeeModal,
  assignAsset,
  unassignEmployeeModal,
  unassignAsset,
  getAssignmentHistory
}

export { Types, Actions }
